<template>
    <div class="school-detail-box video-detail-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/video' }">高考课堂</el-breadcrumb-item>
            <el-breadcrumb-item>课堂详情</el-breadcrumb-item>
        </el-breadcrumb>
        <iframe class="video-detail-content" :src="videoUrl">
        </iframe>
    </div>
</template>

<script>
import { getVideoUrl } from '@/api/video'
export default {
    data() {
        return {
            controls: false,
            videoUrl: '',
        }
    },
    mounted() {
        let id = this.$route.query.id;
        this.getVideoUrl(id);
    },
    methods: {
        playVideo() {
            let video = this.$refs.video;
            this.controls = true;
            video.play();
        },
        getVideoUrl(id) {
            getVideoUrl(id).then( res => {
                this.videoUrl = res.data;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
.video-detail-content {
    @include gwidth;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10); 
    padding: 24px;
    margin-top: 24px;
    p {
        color: #2c2e33;
        font-size: 18px;
        margin-top: 0;
    }
    .play-video {
        position: relative;
        video {
            height: 638px;
        }
        img {
            width: 54px;
            height: 54px;
            position: absolute;
            z-index: 999;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
        }
    }
    
}
</style>